import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  NgForm,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertType } from '@fuse/components/alert';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { Subscription } from 'rxjs';
import { FuseCardModule } from '@fuse/components/card';
import { FuseAlertModule } from '@fuse/components/alert';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'auth-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  providers: [TranslocoService],
  imports: [
    FuseCardModule,
    FuseAlertModule,
    TranslocoModule,
    LanguagesModule,
    InputTextModule,
    PasswordModule,
    ProgressSpinnerModule,
    ButtonModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  standalone: true,
})
export class AuthSignInComponent implements OnInit, OnDestroy {
  @ViewChild('signInNgForm') signInNgForm: NgForm;

  alert: { type: FuseAlertType; message: string } = {
    type: 'success',
    message: '',
  };
  signInForm: UntypedFormGroup;
  showAlert: boolean = false;
  subcriber: Subscription;
  showPassword: boolean = false;
  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _userService: UserService,
    private _formBuilder: UntypedFormBuilder,
    private _router: Router,
    public translocoService: TranslocoService
  ) {}
  ngOnDestroy(): void {
    this.subcriber.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.subcriber = this._authService.authenticated$.subscribe(auth => {
      if (auth) this._router.navigate(['']);
      else {
        localStorage.removeItem('accessToken');
      }
    });

    // Create the form
    this.signInForm = this._formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required],
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Sign in
   */
  signIn(): void {
    // Return if the form is invalid
    if (this.signInForm.invalid) {
      return;
    }

    // Disable the form
    this.signInForm.disable();

    // Hide the alert
    this.showAlert = false;

    // Sign in
    this._authService.signIn(this.signInForm.value).subscribe({
      next: res => {
        const redirectURL2 =
          this._activatedRoute.snapshot.queryParamMap.get('redirectURL') ||
          'apps';

        this._router.navigateByUrl(redirectURL2);
      },
      error: response => {

        // Re-enable the form
        this.signInForm.enable();

        // Reset the form
        this.signInNgForm.resetForm();

        // Set the alert
        this.alert = {
          type: 'error',
          message: 'Неправильный логин или пароль',
        };

        // Show the alert
        this.showAlert = true;
      },
    });
  }
  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }
}
